module.exports = __webpack_public_path__ + "static/media/icon-selfie.4cf25f5d.svg";